import PropTypes from 'prop-types';
import React from 'react';

import { getBgColor } from '$utilities/data';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ProjectCategoryLinks = ({
    categories = [],
    className
}) => {
    return (
        <>
            {categories.map((item, i) => {
                if (!item) { return null; }

                const total = item.projects?.total;
                let classes = 'type-style-6 filter-span h-full border rounded-r-full text-center w-[50px] md:w-[55px] flex items-center justify-end -ml-[50px] md:-ml-[55px] ';
                classes += total?.length > 1 ? 'group-hover:-ml-[12px] group-hover:md:-ml-[17.5px] filter-button__total_2' : 'group-hover:-ml-[15px] group-hover:md:-ml-[20px] filter-button__total_1';

                return (
                    <div
                        className={`flex ${className || ''}`}
                        key={i}>
                        <a
                            className='relative flex flex-row filter-button whitespace-nowrap group'
                            data-selected='false'
                            href={item.url}>
                            <span className='type-style-4 border rounded-full px-14 py-5 bg-foreground z-10'>
                                {item.title}
                            </span>
                            <span
                                className={classes}
                                style={{ backgroundColor: getBgColor(item.categoryFilterColour) }}>
                                <p className='mr-15'>
                                    {total}
                                </p>
                            </span>
                        </a>
                    </div>
                );
            })}
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    categories: PropTypes.arrayOf(PropTypes.shape({
        projects: PropTypes.shape({
            total: PropTypes.number
        }),
        slug: PropTypes.string,
        title: PropTypes.string,
        url: PropTypes.string
    })),
    className: PropTypes.string
};
ProjectCategoryLinks.propTypes = propTypes;

export default ProjectCategoryLinks;
